import { useEffect } from "react";

export const usePreventZoom = (enabled = true) => {
	useEffect(() => {
		if (!enabled) {
			return;
		}

		const handleTouch = (e: TouchEvent) => {
			if (e.touches.length > 1) {
				e.preventDefault();
			}
		};

		document.addEventListener("touchmove", handleTouch, { passive: false });

		return () => document.removeEventListener("touchmove", handleTouch);
	}, [enabled]);
};
